import { useEffect, useState } from 'react';
import { useT } from '../lib/i18n';
import { liveHeader } from '../lib/live-lesson';
import { fmtTime } from '../lib/time';

/**
 * «Занятие вживую»: the top of the lesson's sheet when it was opened from
 * the Today card — who, when, how far through, minutes left. Its own
 * clock ticks every 30 s and on coming back to the app; it reads only the
 * times it was given, so it stays with this lesson when the next starts.
 */
export function LiveHeader({ startsAt, endsAt, who }: { startsAt: string; endsAt: string; who: string }) {
  const t = useT();
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const i = setInterval(() => setNow(Date.now()), 30_000);
    const back = () => { if (document.visibilityState === 'visible') setNow(Date.now()); };
    document.addEventListener('visibilitychange', back);
    return () => { clearInterval(i); document.removeEventListener('visibilitychange', back); };
  }, []);
  const h = liveHeader(startsAt, endsAt, now);

  return (
    <div className={`livehead livehead--${h.state}`}>
      <div className="livehead__top">
        <span className="livehead__label">
          {h.state === 'on' ? t('co.today.onCourt') : h.state === 'over' ? t('co.live.over') : t('co.today.nextUp')}
        </span>
        <span className="livehead__time">{fmtTime(startsAt)}–{fmtTime(endsAt)}</span>
      </div>
      <div className="livehead__who">{who}</div>
      <div className="livehead__bar" aria-hidden="true">
        <span style={{ width: `${Math.round(h.progress * 100)}%` }} />
      </div>
      {h.state !== 'soon' && (
        <div className="livehead__left">
          {h.state === 'on' ? t('co.today.left', { n: h.left }) : t('co.live.endedAt', { time: fmtTime(endsAt) })}
        </div>
      )}
    </div>
  );
}
